<div class="product-card" [ngClass]="{
    'product-card--layout--grid product-card--size--sm': layout === 'grid-sm',
    'product-card--layout--grid product-card--size--nl': layout === 'grid-nl',
    'product-card--layout--grid product-card--size--lg': layout === 'grid-lg',
    'product-card--layout--list':                        layout === 'list',
    'product-card--layout--horizontal':                  layout === 'horizontal'
}">
    <div class="product-card__primary">
        <!-- <button class="product-card__quickview" *ngIf="viewAddtoCart()" type="button" appClick (click)="showQuickview()" [ngClass]="{'product-card__quickview--preload': showingQuickview}">
            <app-icon name="quickview-16" size="16"></app-icon>
            <span class="fake-svg-icon"></span>
        </button> -->

        <div class="product-card__badges-list">
            <!-- <div *ngIf="{{product.featuresData?.brand" class="product-card__badge product-card__badge--brand">{{product.featuresData?.brand}}</div> -->
            <div *ngIf="discountedPrice" class="product-card__badge product-card__badge--sale">Sale {{discountedRate}}%</div>
            <div *ngIf="product?.badges?.includes('hot')" class="product-card__badge product-card__badge--hot">Hot</div>
            <div *ngIf="product?.badges?.includes('new')" class="product-card__badge product-card__badge--new">New</div>
        </div>

        <div class="product-card__image product-image">
            <a appClick [routerLink]="routerLinkString()" class="product-image__body bg-image" [ngClass]="{'image-cover': product?.layout == 'property'}" style="background-repeat:no-repeat;background-image: url('{{image}}')" (click)="scrollToTop()">
                <!-- <img class="product-image__img" [src]="imageKey ? product?.images[imageKey]?.thumb?.url || product?.images[imageKey]?.url : image" alt=""> -->
            </a>
        </div>
        <div class="product-card__info">
            <div *ngIf="product?.companyData?.name" class="product-card__vendor">
                <a appClick [routerLink]="getVendorLink()" (click)="scrollToTop()">{{ translateHelper.localize(product?.companyData?.name) }}</a>
            </div>
            <div class="product-card__name mb-2">
                <a appClick [routerLink]="routerLinkString()" (click)="scrollToTop()">{{ translateHelper.localize(product?.name) }}</a>
            </div>

            <ul *ngIf="featuredAttributes.length" class="product-card__features-list">
                <li *ngFor="let attribute of featuredAttributes">
                    {{ attribute.name }}:
                    <ng-container *ngFor="let value of attribute.values; let last = last">
                        {{ value.name }}<ng-container *ngIf="!last">, </ng-container>
                    </ng-container>
                </li>
            </ul>
            <ng-container *ngIf="product?.layout == 'property'">
                <div class="product-card__prices mt-0">
                    <ng-container *ngIf="product?.realEstate?.displayPrice?.priceType == 'exact'">
                        <span class="product-card__new-price">{{product.realEstate?.displayPrice?.price|currencyFormat: null : 'symbol' : '1.0-0'}}</span>
                    </ng-container>
                    <ng-container *ngIf="product?.realEstate?.displayPrice?.priceType == 'range'">
                        <span class="product-card__new-price">{{product.realEstate?.displayPrice?.priceRange?.min|currencyFormat: null : 'symbol' : '1.0-0'}} - {{product.realEstate?.displayPrice?.priceRange?.max|currencyFormat: null : 'symbol' : '1.0-0'}}</span>
                    </ng-container>
                    <ng-container *ngIf="product?.realEstate?.displayPrice?.priceType == 'from'">
                        <span class="product-card__new-price"><!-- {{"starting_from"|translate}} --> {{product.realEstate?.displayPrice?.price|currencyFormat: null : 'symbol' : '1.0-0'}}</span>
                    </ng-container>
                    <small class="font-weight-bold" *ngIf="product?.realEstate?.displayPrice?.propertyType =='rent' && product?.realEstate?.displayPrice?.rentType">
                        / {{product?.realEstate?.displayPrice?.rentType|uppercase}}
                    </small>
                </div>
                <ng-container *ngIf="product?.vat == 'I' || product?.vat == 'E'">
                    <span style="font-size: x-small;" class="my-2">{{"inclusive"|translate}}</span>
                </ng-container>
                <div class="property-facilities flex flex-wrap gap-1 md:gap-2">
                    <div *ngFor="let item of sortBy(product?.subtype?.properties,'pos'); index as i">
                        <ng-container *ngIf="i < 4">
                            <app-feature-item [icon]="item?.icon" [title]="translateHelper.localize(item?.name)" [subtitle]="(item.value?.name)?translateHelper.localize(item.value?.name):item.value"></app-feature-item>
                        </ng-container>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="product?.layout != 'property'">
                <ng-container *ngIf="!product?.isOnlyQuotation && !product.isOfferable">
                    <div class="product-card__prices mt-0">
                        <ng-container *ngIf="product.taxedPrice < product.baseTaxedPrice ">
                            <div class="product-card__old-price">{{ product.baseTaxedPrice || product.price|currencyFormat }}</div>
                            <span class="product-card__new-price">{{ product.taxedPrice|currencyFormat }}</span>{{ ' ' }}
                        </ng-container>
                        <ng-container *ngIf="product.taxedPrice >= product.baseTaxedPrice">
                            {{ product.taxedPrice || product.price|currencyFormat }}
                        </ng-container>
                        <small class="font-weight-bold" *ngIf="product?.realEstate?.displayPrice?.propertyType =='rent' && product?.realEstate?.displayPrice?.rentType">
                            / {{product?.realEstate?.displayPrice?.rentType|uppercase}}
                        </small>
                    </div>
                    <ng-container *ngIf="product?.vat == 'I' || product?.vat == 'E'">
                        <span style="font-size: x-small;" class="my-2">{{"inclusive"|translate}}</span>
                    </ng-container>
                </ng-container>
                <div class="mt-2" *ngIf="viewAddtoCart() && product?.quantity?.min > 1">
                    <span style="color: red; font-size: medium;">Minimum Amount: {{product?.quantity?.min}}</span>
                </div>
            </ng-container>
            <small style="margin-top: 0.5rem;" *ngIf="product?.quantityDiscount && product?.quantityDiscount.length">
                <span class="text-highlight">* Discount on quantity puchasing</span>
            </small>
        </div>
    </div>
    <div class="product-card__actions">
        <div class="product-card__buttons mt-1">
            <ng-container *ngIf="viewAddtoCart() && product.layout != 'property'; else productViewButton">
                <button eventCollector eventName="add_to_cart" category="catalog" [companyId]="product.companyData?._id" [itemType]="product.type" [itemId]="product._id" class="btn btn-primary btn-sm py-1" [ngClass]="{'product-card__addtocart': layout !== 'list', 'product-card__addtocart--list': layout === 'list'}" type="button" appClick (click)="addToCart()" [ngClass]="{'btn-loading': addingToCart}">
                    {{"add_cart"|translate}}
                </button>

                <div class="quantity-input">
                    <app-input-number aria-label="Quantity" class="product__quantity-availability" [min]="(product.quantity?.min) ? product.quantity?.min : 1" [max]="product.quantity?.max" [step]="product.quantity?.step" [formControl]="amount"></app-input-number>
                </div>
            </ng-container>
            <ng-template #productViewButton>
                <button class="btn btn-primary btn-sm py-1" [ngClass]="{'product-card__addtocart': layout !== 'list', 'product-card__addtocart--list': layout === 'list'}" type="button" appClick [routerLink]="routerLinkString()" [ngClass]="{'btn-loading': addingToCart}">
                    {{"view_item"|translate}}
                </button>

                <ng-container *ngIf="product.layout == 'property'">
                    <ng-container *ngIf="whatsapp; else sendInquiry;">
                        <a  eventCollector eventName="whatsapp" category="catalog" itemType="property" [companyId]="product.companyData?._id" [productId]="product._id" href="https://api.whatsapp.com/send?phone={{whatsapp.number}}&text={{whatsapp.text}}" class="btn btn-primary btn-sm py-1 btn-whatsapp btn-icon" target="_blank">
                            <mat-icon>whatsapp</mat-icon>
                        </a>
                        <a eventCollector eventName="call_phone" category="catalog" itemType="property" [companyId]="product.companyData?._id" [productId]="product._id"  href="tel:{{whatsapp.number}}" class="btn btn-primary btn-sm py-1 btn-icon" target="_blank">
                            <mat-icon>phone</mat-icon>
                        </a>
                    </ng-container>
                    <ng-template #sendInquiry>
                        <button eventCollector eventName="message" category="catalog" itemType="property" [companyId]="product.companyData?._id" [productId]="product._id" type="button" class="btn btn-primary btn-sm py-1" [ngClass]="{'product-card__addtocart': layout !== 'list', 'product-card__addtocart--list': layout === 'list'}" appClick (click)="estateInquiry()">
                            {{"send_inquiry"|translate}}
                        </button>
                    </ng-template>
                </ng-container>
            </ng-template>
        </div>
    </div>
    <!--
    <div class="product-card__sheet" [ngClass]="{'active': openSheet}">
        SHEET
    </div>
    <button class="product-card__sheet-button" [ngClass]="{'active': openSheet}" (click)="openSheet = !openSheet;">
        <mat-icon style="z-index: 1;">{{openSheet ? 'expand_more' : 'info'}}</mat-icon>
    </button>
    -->
</div>
<ng-template #modal>
    <div class="quickview">
        <button class="quickview__close" type="button" appClick (click)="modalRef.hide()">
            <app-icon name="cross-20" size="20"></app-icon>
        </button>

        <app-product *ngIf="product" [product]="product" layout="quickview"></app-product>
    </div>
</ng-template>
